import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const BladeIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-blade"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="33.293 13.464 30.465 16.293 21.979 7.808 23.394 3.566"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="37.535 16.293 34.708 13.465 43.193 4.979 47.434 6.394"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="34.707 20.535 37.535 17.707 46.021 26.192 44.606 30.434"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="30.465 17.707 33.292 20.535 24.808 29.021 20.566 27.606"
        />
        <g transform="translate(23.406 6.406)">
          <path
            d="M13.4226,7.7657 C14.9846,9.3277 14.9846,11.8607 13.4226,13.4227 C11.8606,14.9847 9.3276,14.9847 7.7656,13.4227 C6.2036,11.8607 6.2036,9.3277 7.7656,7.7657 C9.3276,6.2037 11.8606,6.2037 13.4226,7.7657"
            fill="#ffffff"
            className={styles.white}
          />
          <path
            d="M7.05849322 7.05859322C5.10596893 9.01111751 5.10596893 12.1772825 7.05849322 14.1298068 9.01101751 16.0823311 12.1771825 16.0823311 14.1297068 14.1298068 16.0822311 12.1772825 16.0822311 9.01111751 14.1297068 7.05859322 12.1771825 5.10606893 9.01101751 5.10606893 7.05849322 7.05859322ZM12.7154932 8.47280678C13.8869689 9.64428249 13.8869689 11.5441175 12.7154932 12.7155932 11.5440175 13.8870689 9.64418249 13.8870689 8.47270678 12.7155932 7.30123107 11.5441175 7.30123107 9.64428249 8.47270678 8.47280678 9.64418249 7.30133107 11.5440175 7.30133107 12.7154932 8.47280678ZM.440323901 6.36682297C.546349886 6.1118463.839000359 5.99109792 1.09397703 6.0971239 1.3489537 6.20314989 1.46970208 6.49580036 1.3636761 6.75077703.342774634 9.20589268.342774634 11.9827073 1.3636761 14.437823 1.46970208 14.6927996 1.3489537 14.9854501 1.09397703 15.0914761.839000359 15.1975021.546349886 15.0767537.440323901 14.821777-.682774634 12.1208927-.682774634 9.06770732.440323901 6.36682297ZM20.0938595 6.09725031C20.3488215 5.99118925 20.6414886 6.11189738 20.7475497 6.36685946 21.8699406 9.06499516 21.8693846 12.119101 20.7476767 14.820635 20.6417844 15.0756672 20.3491972 15.196569 20.094165 15.0906767 19.8391328 14.9847844 19.718231 14.6921972 19.8241233 14.437165 20.8438852 11.9811592 20.8443909 9.20327469 19.8242503 6.75094054 19.7181893 6.49597846 19.8388974 6.20331137 20.0938595 6.09725031ZM14.437923 19.8245239C14.6928996 19.7184979 14.9855501 19.8392463 15.0915761 20.094223 15.1976021 20.3491996 15.0768537 20.6418501 14.821877 20.7478761 12.1209927 21.8709746 9.06780732 21.8709746 6.36692297 20.7478761 6.1119463 20.6418501 5.99119792 20.3491996 6.0972239 20.094223 6.20324989 19.8392463 6.49590036 19.7184979 6.75087703 19.8245239 9.20599268 20.8454254 11.9828073 20.8454254 14.437923 19.8245239ZM6.36652297.440323901C9.06740732-.682774634 12.1205927-.682774634 14.821477.440323901 15.0764537.546349886 15.1972021.839000359 15.0911761 1.09397703 14.9851501 1.3489537 14.6924996 1.46970208 14.437523 1.3636761 11.9824073.342774634 9.20559268.342774634 6.75047703 1.3636761 6.49550036 1.46970208 6.20284989 1.3489537 6.0968239 1.09397703 5.99079792.839000359 6.1115463.546349886 6.36652297.440323901Z"
            fill="#00000"
            className={styles.defaultColor}
            fillRule="nonzero"
          />
        </g>
      </g>
    </Icon>
  )
}
